module.exports = __webpack_public_path__ + "static/media/file.9c8e81ed.svg";